<template>
    <!--<div @mouseenter="showHandler" @mouseleave="closeHandler" class="mc-tips">-->
    <div  class="mc-tips" :class="{'is-error-pop': showType==='event'}">
        <div ref="reference" @mouseenter="enterHandler" @mouseleave="outHandler">
        <!--<div ref="reference" @mouseenter="showHandler" @mouseleave="closeHandler">-->
            <slot class="mc-tips__slot">1</slot>
        </div>
        <transition name="fade">
            <div class="mc-tips__pop"
                 v-show="visible"
                 ref="popper"
                 :data-transfer="transfer"
                 @mouseenter="enterHandler"
                 @mouseleave="outHandler"
                 v-transfer-dom>
                <div class="mc-tips__pop-container">
                    <div class="mc-tips__content">
                        <slot name="content">{{content}}</slot>
                    </div>
                    <div class="mc-tips__arrow"></div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script type="text/ecmascript-6">
    /**
     * 提供配置项>>>
     * content          提示内容
     * placement        是否显示图标      默认false
     * delay            延迟多少秒后显示  默认0
     */
    import Popper from '../mixins/popper';
    import TransferDom from '../directives/transfer-dom';
    import {debounce} from 'lodash';

    export default {
        name: 'mc-tips',
        directives: {TransferDom},
        mixins: [Popper],
        props: {
            content: {
                type: [String, Number],
                default: ''
            },
            placement: {
                type: String,
                default: 'top'
            },
            delay: {
                type: Number,
                default: 100
            },
            transfer: {
                type: Boolean,
                default: true
            },
            showType: {
                type: String,
                enumeration: ['hover', 'event'],
                default: 'hover'
            }
        },
        data: function () {
            return {
                visible: false
            }
        },
        watch: {
            content () {
                this.updatePopper();
            }
        },
        computed: {},
        methods: {
            enterHandler: function () {
                if(this.showType !== 'hover'){
                    return
                }
                this.showHandler();
            },
            outHandler: function () {
                if(this.showType !== 'hover'){
                    return
                }
                this.closeHandler();
            }
        },
        beforeCreate: function () {
            //防抖处理
            this.showHandler = (e) => {
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.visible = true;
                }, this.delay);
            };

            this.closeHandler = debounce((e) => {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.visible = false;
                    }, 100);
                }
            }, 250, {
                leading: true,
                trailing: true,
                maxWait: 300
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/base-tips.vue